<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-radio-button-group [(ttModel)]="selectedTab">
            <tt-radio-button ttValue="BASIS" ttLabel="bg_srcrewmenu_main_basis"></tt-radio-button>
            <tt-radio-button ttValue="MEMBEROF" ttLabel="bg_srcrewmenu_main_memberof"></tt-radio-button>
            <tt-radio-button ttValue="OTHER" ttLabel="bg_srcrewmenu_main_other"></tt-radio-button>
        </tt-radio-button-group>
    </tt-card>
    <tt-card *ngIf="selectedTab === 'BASIS'" class="col-xs-12 sp-0">
        <tt-input ttLabel="firstname" [ttModel]="page.firstname" ttReadonly></tt-input>
        <tt-input ttLabel="lastname" [ttModel]="page.lastname" ttReadonly></tt-input>
        <tt-input ttLabel="cellphone" [ttModel]="page.cellphone" ttReadonly>
            <a buttons [href]="'tel:' + page.cellphone" class="btn btn-success" [attr.aria-label]="page.cellphone"><span class="fas fa-phone" aria-hidden="true"></span></a>
        </tt-input>
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="page.isactive"></tt-checkbox>
        <tt-input ttLabel="email" [ttModel]="page.email" ttReadonly></tt-input>
        <tt-input ttLabel="private_car_regno" [ttModel]="page.private_car_regno" ttReadonly></tt-input>
        <tt-button ttText="srcrewmenu_edit" ttIcon="fas fa-chevron-right" ttIconPullRight ttTextAlign="left" ttGoto="srcrew" [ttGotoParms]="{ resource_id: page.resource_id, srcrew_keyno: page.srcrew_keyno }"></tt-button>
    </tt-card>
    <tt-card *ngIf="selectedTab === 'MEMBEROF'" class="col-xs-12 sp-0">
        <tt-list [ttData]="memberships"></tt-list>
        <tt-button ttText="srcrewmenu_add_belongto" ttIcon="fas fa-plus" ttIconPullRight ttTextAlign="left" ttGoto="srcrewresource" [ttGotoParms]="{ srcrewresource_keyno: '0', resource_id: '0', srcrew_keyno: page.srcrew_keyno }"></tt-button>
    </tt-card>
    <tt-card *ngIf="selectedTab === 'OTHER'" class="col-xs-12 sp-0">
        <tt-input ttLabel="cim_id" [ttModel]="page.cim_id" ttReadonly></tt-input>
        <tt-input ttLabel="frr_id" [ttModel]="page.frr_id" ttReadonly></tt-input>
    </tt-card>
</tt-page>
